import { Helpers } from '../../helpers';
import { IBudgetCategory } from '../../interfaces/ibudget-category';
import { BudgetCategoryUnitOfMeasure } from '../budget-category-unit-of-measure';
import { Function } from '../function';
import { Project } from '../project';
import { ProjectType } from '../project-type';

export class BudgetCategoryBase {
  BudgetCategoryId: number;
  Name: string;
  Description: string | null;
  BudgetYear: number | null;
  Quantity: number | null;
  UnitRate: number | null;
  TotalBudget: number | null;
  IsActive: boolean;
  FunctionId: number | null;
  ProjectTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  BudgetCategoryUnitOfMeasureId: number | null;

  Projects_BudgetCategory?: Array<Project> | null;
  BudgetCategoryUnitOfMeasure?: BudgetCategoryUnitOfMeasure;
  Function?: Function;
  ProjectType?: ProjectType;

  constructor(item?: IBudgetCategory) {
    if (item) {

      this.BudgetCategoryId = item.BudgetCategoryId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.BudgetYear = item.BudgetYear;
      this.Quantity = item.Quantity;
      this.UnitRate = item.UnitRate;
      this.TotalBudget = item.TotalBudget;
      this.IsActive = item.IsActive;
      this.FunctionId = item.FunctionId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.BudgetCategoryUnitOfMeasureId = item.BudgetCategoryUnitOfMeasureId;

      this.Projects_BudgetCategory = Helpers.createClassArray(Project, item.Projects_BudgetCategory);
      this.BudgetCategoryUnitOfMeasure = new BudgetCategoryUnitOfMeasure(item.BudgetCategoryUnitOfMeasure);
      this.Function = new Function(item.Function);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}